<template>
  <div>
    <!--begin::Dashboard-->
    <div class="row">
      <div class="col-lg-4 col-xxl-4">
        <!--begin::Mixed Widget 1-->
        <div class="card card-custom bg-gray-100 card-stretch gutter-b">
          <!--begin::Header-->
          <div class="card-header border-0 bg-danger py-5">
            <h3 class="card-title font-weight-bolder text-white">{{$t('CONTENT.MAKE_OFFERS')}}</h3>
          </div>
          <!--end::Header-->
          <!--begin::Body-->
          <div class="card-body p-0 position-relative overflow-hidden">
            <!--begin::Chart-->
            <div id="kt_mixed_widget_1_chart" class="card-rounded-bottom bg-danger" style="height: 100px"></div>
            <!--end::Chart-->
            <!--begin::Stats-->
            <div class="card-spacer mt-n25">
              <!--begin::Row-->
              <div class="row m-0">
                <div class="col bg-light-danger px-6 py-8 rounded-xl mb-7">
                  <router-link to="/offers" class="text-success font-weight-bold font-size-h6 mt-2">
															<span class="svg-icon svg-icon-3x svg-icon-danger d-block my-2">
																<!--begin::Svg Icon | path:assets/media/svg/icons/Communication/Add-user.svg-->
																<i class="fa fa-donate font-weight-bolder text-danger" style="font-size: 2rem;"></i>
                                <!--end::Svg Icon-->
															</span>
                  {{$t('CONTENT.MAKE_OFFERS')}}</router-link>
                </div>
              </div>
              <!--end::Row-->
            </div>
            <!--end::Stats-->
          </div>
          <!--end::Body-->
        </div>
        <!--end::Mixed Widget 1-->
      </div>
      <div class="col-lg-4 col-xxl-4">
        <!--begin::Mixed Widget 1-->
        <div class="card card-custom bg-gray-100 card-stretch gutter-b">
          <!--begin::Header-->
          <div class="card-header border-0 bg-warning py-5">
            <h3 class="card-title font-weight-bolder text-white">{{$t('AUTH.GENERAL.INQUIRY_BUTTON')}}</h3>
          </div>
          <!--end::Header-->
          <!--begin::Body-->
          <div class="card-body p-0 position-relative overflow-hidden">
            <!--begin::Chart-->
            <div id="kt_mixed_widget_1_chart" class="card-rounded-bottom bg-warning" style="height: 100px"></div>
            <!--end::Chart-->
            <!--begin::Stats-->
            <div class="card-spacer mt-n25">
              <!--begin::Row-->
              <div class="row m-0">
                <div class="col bg-light-warning px-6 py-8 rounded-xl mb-7">
                  <router-link to="/inquiry" class="text-success font-weight-bold font-size-h6 mt-2">
															<span class="svg-icon svg-icon-3x svg-icon-primary d-block my-2">
																<!--begin::Svg Icon | path:assets/media/svg/icons/Communication/Add-user.svg-->
                                <i class="fa fa-comments font-weight-bolder text-warning" style="font-size: 2rem;"></i>
                                <!--end::Svg Icon-->
															</span>
                    {{$t('AUTH.GENERAL.INQUIRY_BUTTON')}}</router-link>
                </div>
              </div>
              <!--end::Row-->
            </div>
            <!--end::Stats-->
          </div>
          <!--end::Body-->
        </div>
        <!--end::Mixed Widget 1-->
      </div>
      <div class="col-lg-4 col-xxl-4">
        <!--begin::Mixed Widget 1-->
        <div class="card card-custom bg-gray-100 card-stretch gutter-b">
          <!--begin::Header-->
          <div class="card-header border-0 bg-primary py-5">
            <h3 class="card-title font-weight-bolder text-white">{{$t('QUOTATION.Offer')}}</h3>
          </div>
          <!--end::Header-->
          <!--begin::Body-->
          <div class="card-body p-0 position-relative overflow-hidden">
            <!--begin::Chart-->
            <div id="kt_mixed_widget_1_chart" class="card-rounded-bottom bg-primary" style="height: 100px"></div>
            <!--end::Chart-->
            <!--begin::Stats-->
            <div class="card-spacer mt-n25">
              <!--begin::Row-->
              <div class="row m-0">

                <div class="col bg-light-primary px-6 py-8 rounded-xl">
                  <router-link to="/quotation" class="text-success font-weight-bold font-size-h6 mt-2">
															<span class="svg-icon svg-icon-3x svg-icon-primary d-block my-2">
																<!--begin::Svg Icon | path:assets/media/svg/icons/Communication/Urgent-mail.svg-->
                                <i class="fa fa-user-friends font-weight-bolder text-primary" style="font-size: 2rem;"></i>
                                <!--end::Svg Icon-->
															</span>
                    {{$t('QUOTATION.Offer')}}</router-link>
                </div>
              </div>
              <!--end::Row-->
            </div>
            <!--end::Stats-->
          </div>
          <!--end::Body-->
        </div>
        <!--end::Mixed Widget 1-->
      </div>
      <div class="col-lg-4 col-xxl-4">
        <!--begin::Mixed Widget 1-->
        <div class="card card-custom bg-gray-100 card-stretch gutter-b">
          <!--begin::Header-->
          <div class="card-header border-0 bg-info py-5">
            <h3 class="card-title font-weight-bolder text-white">{{$t('QUOTATION.Quotation_record')}}</h3>
          </div>
          <!--end::Header-->
          <!--begin::Body-->
          <div class="card-body p-0 position-relative overflow-hidden">
            <!--begin::Chart-->
            <div id="kt_mixed_widget_1_chart" class="card-rounded-bottom bg-info" style="height: 100px"></div>
            <!--end::Chart-->
            <!--begin::Stats-->
            <div class="card-spacer mt-n25">
              <!--begin::Row-->
              <div class="row m-0">

                <div class="col bg-light-info px-6 py-8 rounded-xl">
                  <router-link to="/quotationRecord" class="text-success font-weight-bold font-size-h6 mt-2">
															<span class="svg-icon svg-icon-3x svg-icon-info d-block my-2">
																<!--begin::Svg Icon | path:assets/media/svg/icons/Communication/Urgent-mail.svg-->
                                <i class="fa fa-user-check font-weight-bolder text-info" style="font-size: 2rem;"></i>
                                <!--end::Svg Icon-->
															</span>
                    {{$t('QUOTATION.Quotation_record')}}</router-link>
                </div>
              </div>
              <!--end::Row-->
            </div>
            <!--end::Stats-->
          </div>
          <!--end::Body-->
        </div>
        <!--end::Mixed Widget 1-->
      </div>
      <div class="col-lg-4 col-xxl-4">
        <!--begin::Mixed Widget 1-->
        <div class="card card-custom bg-gray-100 card-stretch gutter-b">
          <!--begin::Header-->
          <div class="card-header border-0 bg-success py-5">
            <h3 class="card-title font-weight-bolder text-white">{{$t('CONTENT.MY_INFORNATIONAL')}}</h3>
          </div>
          <!--end::Header-->
          <!--begin::Body-->
          <div class="card-body p-0 position-relative overflow-hidden">
            <!--begin::Chart-->
            <div id="kt_mixed_widget_1_chart" class="card-rounded-bottom bg-success" style="height: 100px"></div>
            <!--end::Chart-->
            <!--begin::Stats-->
            <div class="card-spacer mt-n25">
              <!--begin::Row-->
              <div class="row m-0">

                <div class="col bg-light-success px-6 py-8 rounded-xl">
                  <router-link to="/info" class="text-success font-weight-bold font-size-h6 mt-2">
															<span class="svg-icon svg-icon-3x svg-icon-success d-block my-2">
																<!--begin::Svg Icon | path:assets/media/svg/icons/Communication/Urgent-mail.svg-->
                                <i class="fa fa-user-secret font-weight-bolder text-success" style="font-size: 2rem;"></i>
                                <!--end::Svg Icon-->
															</span>
                    {{$t('CONTENT.MY_INFORNATIONAL')}}</router-link>
                </div>
              </div>
              <!--end::Row-->
            </div>
            <!--end::Stats-->
          </div>
          <!--end::Body-->
        </div>
        <!--end::Mixed Widget 1-->
      </div>
    </div>
    <div class="row">
      <div class="col-lg-12 col-xxl-12">
        <div class="card card-custom card-stretch gutter-b">
          <div class="card-header border-0">
            <h3 class="card-title font-weight-bolder text-dark">{{$t('CONTENT.Order_Management')}}</h3>
            <div class="card-toolbar">
              <b-button variant="primary" v-on:click="openOrderList()">{{$t('CONTENT.See_More')}}</b-button>
            </div>
          </div>
          <div class="card-body pt-7 pb-7 mt-n3 border-top">
            <deailList :productPageList="productPageList" :user="user" :loadOrderList="loadOrderList"></deailList>
          </div>
        </div>
      </div>
    </div>
    <b-modal ref="orderList" hide-footer size="xl">
      <template v-slot:modal-header="{ close }">
        <h5>{{$t('ORDER.My_order')}}</h5>
        <b-button size="sm" variant="outline-danger" @click="close()">
          {{$t('CRAFTVALUE.Close')}}
        </b-button>
      </template>

      <div class="d-block text-center">
        <div>
          <v-row class="pt-3 pb-3">
            <v-col class="border text-left">
              <div class="text-muted border-bottom">{{$t('ORDER.inquire')}}</div>
              <v-row>
                <v-col>
                  <form class="form">
                    <div class="row pt-6">
                      <div class="col-md-12 col-lg-4">
                        <div class="form-group" style="margin-bottom: 0rem;">
                          <div class="input-group input-group-solid">
                            <div class="input-group-prepend"><span class="input-group-text">{{$t('ORDER.Product_technology')}}:</span></div>
                            <input type="text" class="form-control form-control-sm" v-model="productTechnology"/>
                          </div>
                        </div>
                      </div>
                      <div class="col-md-12 col-lg-4">
                        <div class="form-group" style="margin-bottom: 0rem;">
                          <div class="input-group input-group-solid">
                            <div class="input-group-prepend"><span class="input-group-text">{{$t('ORDER.Order_status')}}:</span></div>
                            <select class="form-control form-control-sm" v-model="orderStatus" v-on:change="loadOrderList">
                              <option value=""></option>
                              <option value="1">{{$t('ONLINE.unconfirmed')}}</option>
                              <option value="2">{{$t('ONLINE.Pending_Approval')}}</option>
                              <option value="3">{{$t('ONLINE.due')}}</option>
                              <option value="4">{{$t('ONLINE.In_Production')}}</option>
                            </select>
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                </v-col>
              </v-row>
              <v-row class="pl-3 pr-3 border-bottom">
                <v-col cols="12" class="text-right pt-0">
                  <b-button variant="primary" size="sm" v-on:click="loadOrderList">{{$t('ORDER.inquire')}}</b-button>&nbsp;
                  <form :action="exportUrl" method="post" enctype="multipart/form-data" style="display:inline;">
                    <input type="text" v-show="false" name="concatValue" :value="productTechnology" />
                    <input type="text" v-show="false" name="status" :value="orderStatus" />
                    <input type="text" v-show="false" name="defaultDb" :value="user.defaultDb" />
                    <input type="text" v-show="false" name="groupManageId" :value="user.groupManageId" />
                    <input type="text" v-show="false" name="userId" :value="user.recordId" />
                    <button type="submit" class="btn-sm btn btn-secondary">{{$t('ORDER.derive')}}</button>
                  </form>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <div class="row">
            <div class="col-xl-12 text-left">
              <deailList :productPageList="productPageList" :user="user" :loadOrderList="loadOrderList"></deailList>
              <div class="row pt-3">
                <div class="col-xl-12 text-right">
                  <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
                                 :current-page="currentPage" :page-sizes="[5, 10, 30, 50]" :page-size="pageSize"
                                 layout="total, ->, prev, next" :total="totalPages">
                  </el-pagination>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import i18nService from "@/core/services/i18n.service";
import deailList from "@/view/pages/order/deailList.vue";
export default {
  components: {
    deailList
  },
  data() {
    return {
      productList: [],
      productTechnology:'',
      orderStatus:'',
      productPageList:[],
      currentPage: 1, // 当前页码
      pageSize: 10,  // 每页条目数
      totalPages:0,
      exportUrl:this.url+'is/offer/exportOrder',
      showProductList:[],
      temp:0,
    };
  },
  computed: {
    user: {
      get () {
        return this.$store.getters.currentUser;
      }
    },
    activeLanguage() {
      return i18nService.getActiveLanguage();
    }
  },
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      // 获取所有订单数据
      this.loadOrderList();
    },
    openOrderList(status) {
      this.orderStatus = status;
      this.loadOrderList(1);
    },
    loadOrderList(num){
      const query = {};
      query.concatValue = this.productTechnology;
      query.status = this.orderStatus;
      query.defaultDb = this.user.defaultDb;
      query.groupManageId = this.user.groupManageId;
      query.userId = this.user.recordId;
      query.pageNo = this.currentPage;
      query.pageSize = this.pageSize;
      query.type = 1;
      query.manageFlag = this.user.manageFlag ? 1 : 0;
      const _this = this;
      this.$axios.fetchPost("is/offer/getInterProductPage", query).then(result => {
        _this.productPageList = result.data.list;
        if(_this.productPageList && _this.productPageList.length > 0)
        {
          for(let product of _this.productPageList)
          {
            if(_this.activeLanguage && _this.activeLanguage == 'en' && product.deailList && product.deailList.length > 0)
            {
              product.configMainName = product.configMainEnName;
              for(let deail of product.deailList)
              {
                if(deail.enName)
                {
                  deail.dictValue = deail.enName;
                }
              }
            }
          }
        }
        _this.totalPages = result.data.count;
        if(num)
        {
          this.$refs['orderList'].show()
        }
      }).catch(err => {alert(err)});
    },
    handleSizeChange(newSize){
      this.pageSize = newSize;//重新指定每页数据量
      this.loadOrderList();//带着新的分页请求获取数据
    },
    //监听 页码值 改变的事件
    handleCurrentChange(newPage){
      this.currentPage = newPage;//重新指定当前页
      this.loadOrderList();//带着新的分页请求获取数据
    },
  }
}
</script>
